/**
 * 404 not found router
 * 
 */

import React from 'react';
import Helmet from 'react-helmet';

// Layout

import Article from '../layout/article/article';
import Theme from '../layout/theme/theme';
import Hero from '../layout/hero/hero';

export default function NotFound() {

	return (
		
		<React.Fragment>
			
			<Helmet title="404 Not Found" />
			<Theme theme={null}></Theme>
						
			<Article>

				<Hero layout="bubble"></Hero>
				<h1>404 not found</h1>
				
			</Article>
		
		</React.Fragment>
	);
}



// WEBPACK FOOTER //
// ./src/containers/pages/404.js